import { useEffect } from "react";
import { Input, Radio } from "@gamesb42/ui-kit";

import { corparateDoc } from "./index";
import { observer } from "mobx-react";
import UploadFile from "components/UploadFile";

import { ReactComponent as Pdf } from "./assets/pdf.svg";
import { ReactComponent as Close } from "./assets/close.svg";

import s from "./styles.module.scss";
import { authorizedRequest } from "utils/authorization";
import FileName from "./components/FileName";

const Step2 = observer(() => {
  useEffect(() => {
    const conditionForUpload =
      corparateDoc.values.step2Variant === "upload" &&
      corparateDoc.values.certificateOfRegisteredAddressFile!.name.length > 0;
    const conditionForNotApplicable =
      corparateDoc.values.step2Variant === "notApplicable" &&
      corparateDoc.values.certificateOfRegisteredAddressComment.length > 0;

    if (conditionForUpload || conditionForNotApplicable) {
      corparateDoc.isStepIsValid[2] = true;
    } else {
      corparateDoc.isStepIsValid[2] = false;
    }
  }, [
    corparateDoc.values.step2Variant,
    corparateDoc.values.certificateOfRegisteredAddressComment,
    corparateDoc.values.certificateOfRegisteredAddressFile!.name,
  ]);

  function delFileHandler() {
    if (
      corparateDoc.values.certificateOfRegisteredAddressFile?.docId?.length > 0
    ) {
      corparateDoc.values.needtoDelete.push(
        corparateDoc.values.certificateOfRegisteredAddressFile.docId
      );
    }

    corparateDoc.values.certificateOfRegisteredAddressFile = {
      id: "",
      docId: "",
      name: "",
      value: "",
      size: 0,
    };

    corparateDoc.values.certificateOfRegisteredAddressComment = "";
  }

  return (
    <>
      <p>
        Certificate of registered address, e.g. bank statement/ utility bill*
      </p>
      <Radio.Group value={corparateDoc.values.step2Variant}>
        <Radio
          value="upload"
          onChange={() => {
            delFileHandler();
            corparateDoc.values.step2Variant = "upload";
          }}
        >
          Upload
        </Radio>
        <Radio
          value="notApplicable"
          onChange={() => {
            delFileHandler();
            corparateDoc.values.step2Variant = "notApplicable";
          }}
        >
          Not applicable
        </Radio>
      </Radio.Group>

      {corparateDoc.values.step2Variant === "upload" && (
        <div
          style={{
            marginTop: "32px",
            display: "flex",
            flexDirection: "column",
            gap: "32px",
          }}
        >
          <div className={s.uploadHolder}>
            {(corparateDoc.values.certificateOfRegisteredAddressFile!.size ===
              0 && (
              <UploadFile
                dragText="Drag and drop file*"
                uploadText={`Kindly note that mobile phone bills are not accepted 50 Mb max. weight`}
                onUpload={(e, file) => {
                  corparateDoc.values.certificateOfRegisteredAddressFile!.name =
                    file.name;
                  corparateDoc.values.certificateOfRegisteredAddressFile!.size =
                    file.size;
                  corparateDoc.values.certificateOfRegisteredAddressFile!.value =
                    file;
                }}
              />
            )) || (
              <FileName
                fileName="certificateOfRegisteredAddressFile"
                clearFiles={delFileHandler}
              />
            )}
          </div>
          <Input.TextArea
            style={{ height: "100px" }}
            label="Comment to the uploaded file"
            disabled={
              corparateDoc.values.certificateOfRegisteredAddressFile?.docId
                ?.length > 0
            }
            showCount={true}
            maxLength={200}
            value={corparateDoc.values.certificateOfRegisteredAddressComment}
            onChange={(e) => {
              corparateDoc.values.certificateOfRegisteredAddressComment =
                e.target.value;
            }}
          />
        </div>
      )}

      {corparateDoc.values.step2Variant === "notApplicable" && (
        <div style={{ padding: "32px 0 0 0" }}>
          <Input.TextArea
            style={{ height: "100px" }}
            label="Not applicable? Please explain why*"
            disabled={false}
            showCount={true}
            maxLength={200}
            value={corparateDoc.values.certificateOfRegisteredAddressComment}
            onChange={(e) => {
              corparateDoc.values.certificateOfRegisteredAddressComment =
                e.target.value;
            }}
            placeholder="Not applicable? Please explain why*"
          />
        </div>
      )}
    </>
  );
});

export default Step2;
